import React from 'react';
import config from 'config';
import {connect} from 'react-redux';

import {Link, withRouter} from "react-router-dom";
import {Image} from "react-bootstrap";
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

//APPs
import appRouter from '../../utils/appRouter';
import Utils from '../../utils/utils';
import UserApi from '../../api/user-api';

// COMPONENTS
import Game from './game.component.jsx';

class GamePage extends React.Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		if (!UserApi.canPlay(this.props.user)) {
			this.props.history.push(appRouter.getLink('home'), {
				scrollY: config.application.homeScrollToFormTime
			});
		}
	}

	render() {
		if (this.props.game.isCorrect) {
			Utils.setTemporaryClass("active", 5000, "footer-bar-animation");
		}

		let score = UserApi.getScore(this.props.user);

		let points = [], i = 0, len = config.application.pointsToGainTicket;
		while (++i <= len) points.push(i);

		return (
			<div className="bg-blue-inverse">
				<div className="game-page">
					<Game />

					<div className="game-footer">

						{/*<div className="container-status" id="footer-bar-animation">
							<ul>
								<li>Status</li>
								{points.map((item, i) =>
									<li key={i} className={((score >= (i + 1)) ? "ativo" : "inativo")}>
										<Image
											src={
												Utils.getImgPath() + ((score >= (i + 1)) ? "status-ativo.svg" : "status-inativo.svg")
											} alt=""/>
									</li>
								)}
							</ul>
										</div>*/}

						<div className="container-tickets shadow">
							<span className="title">
								<FormattedMessage id="gamePage.footer.title"/>
							</span>

							<span>
								<FormattedMessage id="gamePage.footer.text.1"/>
								<Link to={appRouter.getLink('tickets')}>
									<FormattedMessage id="gamePage.footer.text.2"/>
								</Link>
								<FormattedMessage id="gamePage.footer.text.3"/>
							</span>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = function (store) {
	return {
		user: store.userState,
		game: store.gameState
	};
};

export default withRouter(connect(mapStateToProps)(GamePage));



// WEBPACK FOOTER //
// ./src/components/pages/gamePage.component.jsx